import moment from "moment";

export const formatDate = (value) => {
    if (value !== undefined) {
        const formattedValue = moment(value).format("DD/MM/YYYY hh:mm")

        return formattedValue;
    }
    return null;
}